/**
 * 2020/4/1 - 14:29
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 *
 */
import http from '../http'
export const queryMailLogPageList = data => {
  return http.request({
    url: '/msg/queryMailLogPageList',
    data,
    method: 'post'
  })
}
// 短信日志列表
export const smsRecordQueryPage = data => {
  return http.request({
    url: '/msg/querySmsLogPageList',
    data,
    method: 'post'
  })
}

// export const channelLogQueryPage = data => {
//   return http.request({
//     url: '/trace/channelLogQueryPage',
//     data,
//     method: 'post'
//   })
// }

export const businessLogQueryPage = data => {
  return http.request({
    url: '/trace/businessLogQueryPage',
    data,
    method: 'post'
  })
}
